import React from 'react';
import { CompareCardCheckbox, CHECKBOX_STYLE } from '@nerdwallet/compare-credit-cards-bar';
export var AddToCompareCtaEnum;

(function (AddToCompareCtaEnum) {
  AddToCompareCtaEnum[AddToCompareCtaEnum["button"] = CHECKBOX_STYLE.BUTTON] = "button";
  AddToCompareCtaEnum[AddToCompareCtaEnum["checkbox"] = CHECKBOX_STYLE.CHECKBOX] = "checkbox";
})(AddToCompareCtaEnum || (AddToCompareCtaEnum = {}));

var AddToCompare = function AddToCompare(_ref) {
  var ccCompareButtonTextAfterClick = _ref.ccCompareButtonTextAfterClick,
      ccCompareButtonTextBeforeClick = _ref.ccCompareButtonTextBeforeClick,
      ccCompareCtaType = _ref.ccCompareCtaType,
      _ref$handleCcCompareC = _ref.handleCcCompareClick,
      handleCcCompareClick = _ref$handleCcCompareC === void 0 ? function () {} : _ref$handleCcCompareC,
      isAnalyticsEnabled = _ref.isAnalyticsEnabled,
      legacyCreditCardId = _ref.legacyCreditCardId;
  return /*#__PURE__*/React.createElement(CompareCardCheckbox, {
    card: {
      id: legacyCreditCardId
    },
    elementStyle: ccCompareCtaType,
    analytics: {
      enabled: isAnalyticsEnabled
    },
    handleCompare: handleCcCompareClick,
    addText: ccCompareButtonTextBeforeClick,
    removeText: ccCompareButtonTextAfterClick
  });
};

export default AddToCompare;